import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MessageGeneralSectionSMSReuseSection from 'components/message/MessageGeneralSectionSMSReuseSection'
import MessageGeneralSectionEmailReuseSection from 'components/message/MessageGeneralSectionEmailReuseSection'
import MessageGeneralSectionInboxAndPushReuseSection from 'components/message/MessageGeneralSectionInboxAndPushReuseSection'
import MessageGeneralSectionWhatsappReuseSection from 'components/message/MessageGeneralSectionWhatsappReuseSection'
import MessageGeneralSectionWechatReuseSection from 'components/message/MessageGeneralSectionWechatReuseSection'
import RecurringMessagePromptTabs from 'components/campaign/campaignCreation/RecurringMessagePromptTabs'
import SmsTipsPrompt from 'components/message/SmsTipsPrompt';
import { MessageChannel, MessageBackendChannel } from 'config/CustomEnums'

const formFieldsMappings = {
    [MessageChannel.email]: {
        component: MessageGeneralSectionEmailReuseSection,
    },
    [MessageChannel.sms]: {
        component: MessageGeneralSectionSMSReuseSection,
    },
    [MessageChannel.whatsapp]: {
        component: MessageGeneralSectionWhatsappReuseSection,
    },
    [MessageChannel.wechat]: {
        component: MessageGeneralSectionWechatReuseSection,
    },
    [MessageChannel.pushAndInbox]: {
        component: MessageGeneralSectionInboxAndPushReuseSection,
    }
}

const renderTabForLanguage = ({ language, channel, setShowTipsForSMS }) => {
    const languageCode = language.code
    const formData = formFieldsMappings[channel]
    console.log("renderTabForLanguage:", channel)
    console.log("formData:", formData)

    return {
        name: language.sourceName,
        content: <formData.component
            language={languageCode}
            setShowTips={() => setShowTipsForSMS(true)}
            isRecurringMessage
        />
    }
};

const getTabs = ({ languages, channel, setShowTipsForSMS }) => {
    if (!languages) {
        return []
    }
    return languages.map(language => renderTabForLanguage({ language, channel, setShowTipsForSMS }))
}

function RecurringMessagePromptBody({ channel }) {
    const languages = useSelector(state => state.language.allList)
    console.log("RecurringMessagePromptBody channel:", channel)

    const [showTipsForSMS, setShowTipsForSMS] = useState(false);

    const tabs = getTabs({ languages, channel, setShowTipsForSMS })

    return (
        <>
        <RecurringMessagePromptTabs tabs={tabs} />
        <SmsTipsPrompt
            show={showTipsForSMS}
            onHide={() => setShowTipsForSMS(false)}
            onConfirm={() => setShowTipsForSMS(false)}
        />
        </>
    );
}

export default RecurringMessagePromptBody;
